import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Icon } from '@shared/components/Icon/Icon.tsx';
import { i18nNameSpace } from '@shared/consts/i18n.ts';

import styles from './EmptyState.module.scss';

interface EmptyStateProps {
  title?: string;
  subtitle?: string;
  className?: string;
}

export function EmptyState({ title, subtitle, className }: EmptyStateProps) {
  const { t } = useTranslation(i18nNameSpace.USERS);

  return (
    <div className={cn(styles.emptyStateWrapper, className)}>
      <Icon
        variant={'closeGray'}
        iconAltText={t('page.adminPanel.advertisers.emptyState.header')}
        stylesClassName={'emptyStateIcon'}
      />
      {title && <p className={styles.emptyStateTitle}>{title}</p>}
      {subtitle && <p className={styles.emptyStateSubtitle}>{subtitle}</p>}
    </div>
  );
}
